import { styled } from "@mui/material/styles";
import { Loop } from "@mui/icons-material";

const StyledSpinner = styled(Loop)`
  animation: rotate 2s linear infinite;
  color: white;
  scale: 3;
  @keyframes rotate {
    100% {
      transform: rotate(-360deg);
    }
  }
`;
export default StyledSpinner;
